/** @format */

export const ShippingLarge = ({color}) => {
    return (
        <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_476_158)">
                <path
                    d="M26.6663 10.6666H22.6663V5.33331H3.99967C2.53301 5.33331 1.33301 6.53331 1.33301 7.99998V22.6666H3.99967C3.99967 24.88 5.78634 26.6666 7.99967 26.6666C10.213 26.6666 11.9997 24.88 11.9997 22.6666H19.9997C19.9997 24.88 21.7863 26.6666 23.9997 26.6666C26.213 26.6666 27.9997 24.88 27.9997 22.6666H30.6663V16L26.6663 10.6666ZM25.9997 12.6666L28.613 16H22.6663V12.6666H25.9997ZM7.99967 24C7.26634 24 6.66634 23.4 6.66634 22.6666C6.66634 21.9333 7.26634 21.3333 7.99967 21.3333C8.73301 21.3333 9.33301 21.9333 9.33301 22.6666C9.33301 23.4 8.73301 24 7.99967 24ZM10.9597 20C10.2263 19.1866 9.18634 18.6666 7.99967 18.6666C6.81301 18.6666 5.77301 19.1866 5.03967 20H3.99967V7.99998H19.9997V20H10.9597ZM23.9997 24C23.2663 24 22.6663 23.4 22.6663 22.6666C22.6663 21.9333 23.2663 21.3333 23.9997 21.3333C24.733 21.3333 25.333 21.9333 25.333 22.6666C25.333 23.4 24.733 24 23.9997 24Z"
                    fill={color}
                />
            </g>
            <defs>
                <clipPath id="clip0_476_158">
                    <rect width="32" height="32" fill={color} />
                </clipPath>
            </defs>
        </svg>
    );
};
